// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// Define a service using a base URL and expected endpoints
const userToken = JSON.parse(localStorage.getItem('user'))

export const fullApi = createApi({
  reducerPath: "fullApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_BACKEND_API_URL}/`  }),
  tagTypes: ['Tasks'],
  endpoints: (builder) => ({
    getAllTasks: builder.query({
        query: () => `tasks`,
        providesTags: ['Tasks']
    }),
    addTask: builder.mutation({
        query: (task) => ({
            url: 'tasks',
            method: 'POST',
            body: task,
        }),
        invalidatesTags: ['Tasks']
    }),
    updateTask: builder.mutation({
      query: (task) => ({
          url: `tasks/${task.id}`,
          method: 'PUT',
          body: {...task},
      }),
      invalidatesTags: ['Tasks']
  }),
    deleteTask: builder.mutation({
        query: ({id}) => ({
            url: `tasks/${id}`,
            method: 'DELETE',
            body: id,
        }),
        invalidatesTags: ['Tasks']
    }),
})
})


export const { useGetAllTasksQuery, useGetTaskQuery, useAddTaskMutation, useUpdateTaskMutation, useDeleteTaskMutation} = fullApi;